"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledExpandLess = exports.StyledButton = exports.Root = exports.classes = void 0;
const Button_1 = require("@mui/material/Button");
const styles_1 = require("@mui/material/styles");
const button_1 = __importDefault(require("../button"));
const ExpandLess_1 = __importDefault(require("../icon/svgs/ExpandLess"));
const PREFIX = "BackToTop";
exports.classes = {
    hidden: `${PREFIX}-hidden`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    opacity: 1,
    transition: "visibility 280s, opacity 280ms linear",
    position: "fixed",
    right: 0,
    bottom: "100px",
    zIndex: 3,
    [`&.${exports.classes.hidden}`]: {
        visibility: "hidden",
        opacity: 0
    }
}));
exports.StyledButton = (0, styles_1.styled)(button_1.default)(({ theme }) => ({
    cursor: "pointer",
    borderRadius: "6px 0 0 6px",
    boxShadow: `0px 8px 10px ${(0, styles_1.alpha)(theme.colours.black, 0.2)}`,
    border: "none",
    backgroundColor: theme.colours.black,
    opacity: 0.5,
    "&:hover": {
        backgroundColor: theme.colours.black,
        opacity: 0.75
    },
    [`&.${Button_1.buttonClasses.root}`]: {
        minWidth: "auto",
        width: "56px",
        height: "56px"
    }
}));
exports.StyledExpandLess = (0, styles_1.styled)(ExpandLess_1.default)(({ theme }) => ({
    fontSize: "36px",
    width: "36px",
    height: "36px",
    color: theme.colours.white
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2JhY2stdG8tdG9wL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpREFBcUQ7QUFDckQsaURBQXFEO0FBQ3JELHVEQUErQjtBQUMvQix5RUFBaUQ7QUFFakQsTUFBTSxNQUFNLEdBQUcsV0FBVyxDQUFDO0FBRWQsUUFBQSxPQUFPLEdBQUc7SUFDckIsTUFBTSxFQUFFLEdBQUcsTUFBTSxTQUFTO0NBQzNCLENBQUM7QUFFVyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDaEQsT0FBTyxFQUFFLENBQUM7SUFDVixVQUFVLEVBQUUsdUNBQXVDO0lBQ25ELFFBQVEsRUFBRSxPQUFPO0lBQ2pCLEtBQUssRUFBRSxDQUFDO0lBQ1IsTUFBTSxFQUFFLE9BQU87SUFDZixNQUFNLEVBQUUsQ0FBQztJQUNULENBQUMsS0FBSyxlQUFPLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRTtRQUN2QixVQUFVLEVBQUUsUUFBUTtRQUNwQixPQUFPLEVBQUUsQ0FBQztLQUNYO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFlBQVksR0FBRyxJQUFBLGVBQU0sRUFBQyxnQkFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3pELE1BQU0sRUFBRSxTQUFTO0lBQ2pCLFlBQVksRUFBRSxhQUFhO0lBQzNCLFNBQVMsRUFBRSxnQkFBZ0IsSUFBQSxjQUFLLEVBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDLEVBQUU7SUFDNUQsTUFBTSxFQUFFLE1BQU07SUFDZCxlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0lBQ3BDLE9BQU8sRUFBRSxHQUFHO0lBQ1osU0FBUyxFQUFFO1FBQ1QsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUNwQyxPQUFPLEVBQUUsSUFBSTtLQUNkO0lBQ0QsQ0FBQyxLQUFLLHNCQUFhLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUMzQixRQUFRLEVBQUUsTUFBTTtRQUNoQixLQUFLLEVBQUUsTUFBTTtRQUNiLE1BQU0sRUFBRSxNQUFNO0tBQ2Y7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsZ0JBQWdCLEdBQUcsSUFBQSxlQUFNLEVBQUMsb0JBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNqRSxRQUFRLEVBQUUsTUFBTTtJQUNoQixLQUFLLEVBQUUsTUFBTTtJQUNiLE1BQU0sRUFBRSxNQUFNO0lBQ2QsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztDQUMzQixDQUFDLENBQUMsQ0FBQyJ9